// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  close: () => 'Închidere',
  error: () => 'Eroare',
  warn: () => 'Avertisment',
  info: () => 'Informaţii',
  confirmation: () => 'Confirmare',
  progressIndeterminate: () => 'În curs',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Între ' + p['FROM_SECTION'] + ' şi ' + p['TO_SECTION'] + '.',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Nu s-a găsit nicio secţiune care să corespundă.',
  indexer_othersLabel: () => '#',
  indexer_keyboardInstructionText: () => 'Apăsaţi Enter pt. a selecta valoarea.',
  indexer_touchInstructionText: () =>
    'Atingeţi de două ori şi menţineţi apăsat pt. a intra în modul Gesturi, apoi trageţi în sus sau în jos pt. a ajuta valoarea.',
  inputPassword_show: () => 'Afişare parolă',
  inputPassword_hide: () => 'Ascundere parolă',
  inputPassword_hidden: () => 'Parolă ascunsă',
  formControl_clear: () => 'Golire',
  formControl_loading: () => 'Se încarcă',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'S-a depăşit lungimea maximă, de ' + p['MAX_LENGTH'] + '.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' caractere rămase.',
  formControl_requiredMessageDetail: () => 'Introduceţi o valoare.',
  select_requiredMessageDetail: () => 'Selectaţi o valoare.',
  select_noMatchesFound: () => 'Nu s-a găsit niciun rezultat.',
  select_oneMatchFound: () => 'S-a găsit un rezultat.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'S-au găsit ' + p['TOTAL_SIZE'] + ' rezultate',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'S-au găsit ' + p['TOTAL_SIZE'] + ' sau mai multe rezultate',
  selectMultiple_selectedValues: () => 'Valori selectate',
  selectMultiple_showSelectedValues: () => 'Afişaţi doar valorile selectate.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' valori selectate.',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Apăsaţi pe Backspace sau Delete pentru a elimina valoarea selectată.',
  selectMultiple_apply: () => 'Aplicare',
  selectMultiple_back: () => 'Înapoi',
  selector_selected: () => 'Casetă de validare bifată',
  selector_unselected: () => 'Casetă de validare nebifată',
  userAssistance_learnMore: () => 'Mai multe informaţii',
  userAssistance_required: () => 'Obligatoriu',
  filePicker_singleFileUploadError: () => 'Încărcaţi doar câte un fişier',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Nu puteţi încărca fişiere de tip ' + p['fileType'],
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Nu puteţi încărca fişiere de tip: ' + p['fileTypes'],
  filePicker_unknownFileTypeUploadError: () => 'necunoscut',
  filePicker_dropzonePrimaryText: () => 'Glisare şi plasare',
  filePicker_dropzoneSecondaryText: () => 'Selectaţi un fişier sau plasaţi unul aici',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Selectaţi fişiere sau plasaţi-le aici',
  filePicker_addFiles: () => 'Adăugare fişiere',
  plural_separator: () => ', ',
  inputNumber_increase: () => 'Creştere',
  inputNumber_decrease: () => 'Scădere',
  inputNumber_converterParseError: () => 'Introduceţi un număr.',
  noData_message: () => 'Nu există niciun element de afişat',
  message_navigationFromMessagesRegion: () =>
    'Se intră în regiunea Mesaje. Apăsaţi F6 pt. a naviga înapoi la elementul focalizat anterior.',
  message_navigationToMessagesRegion: () =>
    'În regiunea Mesaje există mesaje noi. Apăsaţi F6 pt. a naviga la regiunea cu cele mai recente mesaje.',
  messageToast_allMessagesClosed: () => 'Toate mesajele de alertă sunt închise.',
  expandableList_groupCollapse: () => 'Restrâns',
  expandableList_groupExpand: () => 'Extins',
  expandableList_expandCollapseInstructionText: () =>
    'Utilizaţi tastele cu săgeţi pt. a extinde şi a restrânge',
  list_suggestion: () => 'Sugestie',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Etapa ' + p['currentStep'] + ' din ' + p['numberOfSteps'],
  train_current: () => 'Curentă',
  train_visited: () => 'Vizitată',
  train_not_visited: () => 'Nevizitată',
  train_message_type: () => 'Tip mesaj',
  viz_drillable: () => 'Permite detalierea',
  dataVisualization_stateSelected: () => 'Selectată',
  dataVisualization_stateUnselected: () => 'Neselectată',
  dataVisualization_noData: () => 'Nu există date de afişat'
};
export default bundle;
